import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCard from "UI/FnrCard/FnrCard";
import FnrErrorText from "UI/FnrErrorText/FnrErrorText";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrInput2 from "UI/FnrInput2/FnrInput2";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import extendedFieldInputContainers from "../containers";

const { IconContainer, VerticallyCentered } = extendedFieldInputContainers;

const MinMax = () => {
  const [min, setMin] = extendedFieldHooks.useMin();
  const [max, setMax] = extendedFieldHooks.useMax();
  const isReadOnly = extendedFieldHooks.useIsReadOnly();

  return (
    <FnrCard data-cy="ExtendedFields_MinMax">
      <VerticallyCentered>
        <IconContainer $color="textSecondary">
          <FnrIcon icon="fa-calculator fas" />
        </IconContainer>
        <FnrVerticalGap gap={8}>
          <FnrTypography>Optional</FnrTypography>
          <FnrHorizontalGap>
            <FnrInput2
              label="Minimum"
              value={min?.toString() || ""}
              setValue={setMin}
              type="number"
              min={0}
              data-cy="ExtendedFields_Min"
              borderColor="divider"
              disabled={isReadOnly}
            />
            <FnrInput2
              label="Maximum"
              value={max?.toString() || ""}
              setValue={setMax}
              type="number"
              min={0}
              data-cy="ExtendedFields_Max"
              borderColor="divider"
              disabled={isReadOnly}
            />
          </FnrHorizontalGap>
          <FnrErrorText error={min > max}>
            Yikes! That min is more than the max!
          </FnrErrorText>
        </FnrVerticalGap>
      </VerticallyCentered>
    </FnrCard>
  );
};

export default MinMax;
